import { EntityApi, LoopBackAuth } from '../../../sdk';
import { FormBuilder } from '@angular/forms';
import { AbstractWidgetComponent, isNotEmpty } from '../../../utils/util';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
//import 'ag-grid-enterprise/main';
import { DataelementApi } from '../../../sdk/services/custom';
import * as _ from 'lodash';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'metric-widget',
    templateUrl: './metric.component.html',
    providers: [DataelementApi],
    styleUrls: ['./metric.component.scss']

})

export class MetricWidgetComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {
    @Input() id: string;
    metricvalue: any;
    subscriptions: any = [];
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(_dataelementApi: DataelementApi, fb: FormBuilder,
        _loopBackAuth: LoopBackAuth, _entityApi: EntityApi) {
        super(_dataelementApi, fb, _loopBackAuth, _entityApi);
    }

    ngOnInit(): void {
        this._dataelementid = this.id;
        console.log("id->" + this.id);

        this.subscriptions.push(this.getDataElement()
            .subscribe(result => {
                if (result) {
                    this.filter_fields = _.cloneDeep(result['filterfields']);
                    this.options = this.createChartConfig(result);
                }
            }, err => console.error(err)));
    }


    createChartConfig(result): any {
        // there should be only one output field for metric related dataelement
        if (isNotEmpty(result['fields'])) {
            let field = result['fields'][0];
            if (field && isNotEmpty(result['data'])) {
                if (field.unit) {
                }
            }
        }
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/metric/metric.component.ts